/** Prefix for BO preference keys in localStorage (instance-scoped cache). */
export const BO_PREFS_CACHE_PREFIX = "bo-pref:";

/** Keys that must never be synced to UserConfig (auth, i18n cache, etc.). */
export const BO_PREFS_EXCLUDED_LOCAL_KEYS = new Set([
  "token",
  "instance",
  "region",
  "main-language",
  "language",
  "artworksDashboard",
]);

export function isBoPreferenceLogicalKey(key: string): boolean {
  if (BO_PREFS_EXCLUDED_LOCAL_KEYS.has(key)) return false;
  if (key.startsWith("token_")) return false;
  if (key.startsWith("i18next")) return false;
  if (key.startsWith(BO_PREFS_CACHE_PREFIX)) return false;
  return true;
}
